import Styles from './CertLearningPath.module.scss';
import { Tooltip, Typography, Dialog, LinearProgress } from '@mui/material';
import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import FeatherIcon from 'feather-icons-react';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import { useNavigate } from 'react-router-dom';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { useState } from 'react';
import { LoadingBackdrop } from '../LoadingBackdrop/LoadingBackdrop';

export function CertLearningPath({
    data,
    dueDate,
    context,
    setShowNotOnboardedDialog,
    showNotOnboardedDialog,
    onHandleCertificateClick,
    activeStep,
    userLabs,
    onHandleStep,
    onHandleLabClick,
    lpath_id,
    ...props
}) {
    const navigate = useNavigate();
    const [isLoadingOpen, setIsLoadingOpen] = useState(false);
    const getModulesForLab = (labId) =>
        data?.labs.filter(x => x.id === labId)[0].nodeCount;

    const getHoursPerModule = (labId) => {
        const lab = data?.labs?.find(l => l.id === labId);
        return lab?.is_project === 1 ? 2 : 1;
    };

    const getTotalHours = () => {
        return data?.labs?.reduce((sum, lab) => {
            const modules = lab.nodeCount;
            const hoursPerModule = getHoursPerModule(lab.id);
            return sum + (modules * hoursPerModule);
        }, 0) ?? 0;
    };

    const totalCourses = data?.labs?.length || 0;
    const completedCourses =
        userLabs?.filter((lab) => lab.status === 'completed').length || 0;

    const getLabHours = (labId) => {
        const modules = getModulesForLab(labId);
        const hoursPerModule = getHoursPerModule(labId);
        return modules * hoursPerModule;
    };


    const labButtonClick = (data) => {
        onHandleLabClick(data, navigate, 1, lpath_id);
    }
    return (
        <>
            <LoadingBackdrop isOpen={isLoadingOpen} />
            <div data-testid="certLearningPath-header" id="header" className={Styles.header}>
                <div data-testid="certLearningPath-headerContainer" id="headerContainer" className={Styles.headerContainer}>
                    <div data-testid="certLearningPath-headerGrid" id="headerGrid" className={Styles.headerGrid}>
                        <div data-testid="certLearningPath-headerContent" id="headerContent" className={Styles.headerContent}>
                            <div data-testid="certLearningPath-headerTitleSection" id="headerTitleSection" className={Styles.headerTitleSection}>
                                <div data-testid="certLearningPath-logoContainer" id="logoContainer" className={Styles.logoContainer}>
                                    <img
                                        data-testid="certHeader-headerGrid-imgAivagam"
                                        src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.icon}`}
                                        alt="Aivagam"
                                        style={{ background: "white" }}
                                        onError={(e) => e.target.style.display = 'none'}
                                    />
                                </div>
                                <div data-testid="certLearningPath-titleWrapper" id="titleWrapper" className={Styles.titleWrapper}>
                                    <div data-testid="certLearningPath-badge" id="badge" className={Styles.badge}>
                                        <WorkspacePremiumOutlinedIcon className={Styles.badgeIcon} />
                                        {props.t('LearningPath.CertLearningPath.certHeader.certified')}
                                    </div>
                                    <h1>{data.certName}</h1>
                                    {data?.cert_due_date &&
                                        <span
                                            data-testid="certLearningPath-dueDate"
                                            title={props.t('LearningPath.UserLearningPath.dueDate.title')} className={Styles.dueDate}>
                                            <FeatherIcon icon="clock" size='12px'
                                                style={{
                                                    color: 'white',
                                                    marginRight: '4px'
                                                }}
                                            />
                                            {props.t('LearningPath.UserLearningPath.dueDate.descr')}
                                            <span style={{ fontWeight: 600, marginLeft: '0.5ch' }}>{dueDate}</span>
                                        </span>
                                    }
                                </div>
                            </div>

                            <p data-testid="certLearningPath-headerDescription" className={Styles.headerDescription}>
                                {data.certDescr}
                            </p>

                            <div data-testid="certLearningPath-headerButtons" id="headerButtons" className={Styles.headerButtons}>
                                <Tooltip
                                    title={
                                        (data?.certificate) ? (
                                            <Typography fontSize={16}>{props.t('LearningPath.UserLearningPath.tooltip.completed')}</Typography>
                                        ) : (
                                            <Typography fontSize={16}>{props.t('LearningPath.UserLearningPath.tooltip.notCompleted')}</Typography>
                                        )
                                    }
                                    arrow
                                    placement="top"
                                    sx={{ fontSize: 20 }}
                                >
                                    <span>
                                        <button
                                            data-testid="certLearningPath-certButton"
                                            id="certButton"
                                            className={Styles.certButton}
                                            disabled={!context?.user?.onboarded || !data?.certificate}
                                            onClick={() => {
                                                if (!context?.user?.onboarded) {
                                                    setShowNotOnboardedDialog(true);
                                                    return;
                                                }
                                                if (!data?.certificate) {
                                                    console.warn("Certificate not available yet.");
                                                    return;
                                                }
                                                onHandleCertificateClick();
                                            }}
                                        >
                                            {props.t('LearningPath.CertLearningPath.button.certificate')}
                                        </button>
                                        <Dialog
                                            open={showNotOnboardedDialog}
                                            onClose={() => setShowNotOnboardedDialog(false)}
                                            maxWidth="xs"
                                        >
                                            <div id="tcContainer" data-testid="certLearningPath-tcContainer" className={Styles.tcContainer} style={{ minWidth: 360, padding: 20 }}>
                                                <h3 data-testid="certLearningPath-tcTitle" id="tcTitle" className={Styles.tcTitle}>{props.t('LearningPath.UserLearningPath.profile.heading')}</h3>
                                                <p data-testid="certLearningPath-tcBody" id="tcBody" className={Styles.tcBody}>
                                                    {props.t('LearningPath.UserLearningPath.profile.message')}
                                                </p>

                                                <div data-testid="certLearningPath-tcActions" id="tcActions" className={Styles.tcActions}>
                                                    <AivagamButton
                                                        data-testid="certLearningPath-closeNotOnboarded"
                                                        id="closeNotOnboarded"
                                                        buttonText="Close"
                                                        onClick={() => setShowNotOnboardedDialog(false)}
                                                        type="cancel"
                                                    />
                                                    <AivagamButton
                                                        data-testid="certLearningPath-goToAccount"
                                                        id="goToAccount"
                                                        buttonText="Go to Account"
                                                        onClick={() => {
                                                            setShowNotOnboardedDialog(false);
                                                            navigate("/account"); // or /account/profile
                                                        }}
                                                        type="confirm"
                                                    />
                                                </div>
                                            </div>
                                        </Dialog>
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                        <div data-testid="certLearningPath-statsGrid" id="statsGrid" className={Styles.statsGrid}>
                            <div data-testid="certLearningPath-statCard" id="course" className={Styles.statCard}>
                                <ImportContactsOutlinedIcon className={Styles.statIcon} />
                                <p data-testid="certLearningPath-statNumber" id="courseNumber" className={Styles.statNumber}>{data?.labs?.length}</p>
                                <p className={Styles.statLabel}>{props.t(`LearningPath.CertLearningPath.certHeader.coursesAvailable`)}</p>
                            </div>
                            <div data-testid="certLearningPath-hours" id="hours" className={Styles.statCard}>
                                <AccessTimeOutlinedIcon className={Styles.statIcon} />
                                <p
                                    data-testid="certLearningPath-hourseIcon"
                                    id="hourseIcon"
                                    className={Styles.statNumber}
                                >
                                    {getTotalHours()}
                                </p>
                                <p className={Styles.statLabel}>{props.t(`LearningPath.CertLearningPath.certHeader.learningHours`)}</p>
                            </div>
                            <div data-testid="certLearningPath-statCard" id="learning" className={Styles.statCard}>
                                <SchoolOutlinedIcon data-testid="certLearningPath-statIcon" id="learningIcon" className={Styles.statIcon} />
                                <p className={Styles.statNumber}>100%</p>
                                <p className={Styles.statLabel}>{props.t(`LearningPath.CertLearningPath.certHeader.onlineLearning`)}</p>
                            </div>
                            <div data-testid="certLearningPath-statCard" id="certificate" className={Styles.statCard}>
                                <WorkspacePremiumOutlinedIcon data-testid="certLearningPath-statIcon" id="certificateIcon" className={Styles.statIcon} />
                                <p className={Styles.statNumber}>{props.t(`LearningPath.CertLearningPath.certHeader.nasscom`)}</p>
                                <p className={Styles.statLabel}>{props.t(`LearningPath.CertLearningPath.certHeader.certification`)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={Styles.progressContainer}>
                <div
                    data-testid="certLearningPath-progressSummaryCard"
                    id="progressSummaryCard"
                    className={Styles.progressSummaryCard}
                >
                    <div
                        data-testid="certLearningPath-progressSummaryHeader"
                        id="progressSummaryHeader"
                        className={Styles.progressSummaryHeader}
                    >
                        <div
                            data-testid="certLearningPath-progressSummaryText"
                            id="progressSummaryText"
                            className={Styles.progressSummaryText}
                        >
                            <h2 data-testid="certLearningPath-progressSummaryTitle" className={Styles.progressSummaryTitle}>{props.t(`LearningPath.CertLearningPath.certBody.yourProgress`)}</h2>
                            <p data-testid="certLearningPath-progressSummarySubtitle" className={Styles.progressSummarySubtitle}>
                                {props.t('LearningPath.CertLearningPath.certBody.track', { certName: data?.certName })}
                            </p>
                        </div>

                        <div
                            data-testid="certLearningPath-progressSummaryNumbers"
                            id="progressSummaryNumbers"
                            className={Styles.progressSummaryNumbers}
                        >
                            <span data-testid="certLearningPath-progressSummaryPercent" className={Styles.progressSummaryPercent}>
                                {data?.completion_percentage}%
                            </span>
                            <span data-testid="certLearningPath-progressSummaryCount" className={Styles.progressSummaryCount}>
                                {props.t('LearningPath.CertLearningPath.certBody.courseCount', { completedCourses: completedCourses, totalCourses: totalCourses })}
                            </span>
                        </div>
                    </div>

                    <div
                        data-testid="certLearningPath-progressSummaryBarWrapper"
                        id="progressSummaryBarWrapper"
                        className={Styles.progressSummaryBarWrapper}
                    >
                        <LinearProgress
                            variant="determinate"
                            value={data?.completion_percentage}
                            className={Styles.progressSummaryBar}
                        />
                    </div>
                </div>
                <div data-testid="certLearningPath-mainContainer" id="mainContainer" className={Styles.mainContainer}>
                    <div data-testid="certLearningPath-sidebar" id="sidebar" className={Styles.sidebar}>
                        <h2 data-testid="certLearningPath-sidebarTitle" className={Styles.sidebarTitle}>{props.t(`LearningPath.CertLearningPath.certBody.learningPath`)}</h2>

                        <div data-testid="certLearningPath-courseList" id="courseList" className={Styles.courseList}>
                            <div
                                data-testid="certLearningPath-progressLineActive"
                                id="progressLineActive"
                                className={Styles.progressLineActive}
                                style={{
                                    height: `${(data?.labs?.length) * 111}px`
                                }}
                            ></div>
                            <div data-testid="certLearningPath-courseNodes" id="courseNodes" className={Styles.courseNodes}>
                                {userLabs.map((course, index) => (
                                    <button
                                        data-testid="certLearningPath-courseNode"
                                        id="courseNode"
                                        key={course.id}
                                        onClick={() => onHandleStep(index)}
                                        className={`${Styles.courseNode} ${activeStep === index ? Styles.courseNodeActive : ''} ${course.isPending ? Styles.cardDisabled : ""}`}
                                    >
                                        <div data-testid="certLearningPath-courseImage" id="imagePlaceholder" className={`${Styles.courseImage} ${activeStep === index ? Styles.courseImageActive : ''}`}>
                                            {course.icon ? (
                                                <img
                                                    src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${course.icon}`}
                                                    alt={course.name}
                                                />
                                            ) : (
                                                <div data-testid="certLearningPath-imagePlaceholder" className={Styles.imagePlaceholder}></div>
                                            )}
                                        </div>

                                        <div data-testid="certLearningPath-courseInfo" className={Styles.courseInfo}>
                                            <p data-testid="certLearningPath-courseTitle" className={Styles.courseTitle}>{course.name}</p>
                                            <span
                                                data-testid="certLearningPath-statusBadge"
                                                className={`${Styles.statusBadge} ${course.isPending
                                                    ? Styles.disabled
                                                    : Styles[course.status.toLowerCase().replace('_', '-')]
                                                    }`}
                                            >
                                                {course?.isPending ? "License Expired" : course?.status === "not_started" ? "Start Learning" : course?.status === "completed" ? "Completed" : course?.status === "failed" ? "Failed" : "Continue Learning"}
                                            </span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div data-testid="certLearningPath-detailsPanel" id="detailsPanel" className={Styles.detailsPanel}>
                        <div data-testid="certLearningPath-detailsContent" id="detailsContent" className={Styles.detailsContent}>
                            <div data-testid="certLearningPath-detailsTitle" id="detailsTitle"
                                style={{ display: 'flex', justifyContent: 'space-between' }}
                            >
                                <h2 className={Styles.detailsTitle}>{userLabs[activeStep].name}</h2>
                                <span
                                    data-testid="certLearningPath-labStatus"
                                    className={`${Styles.labStatus} ${userLabs[activeStep].isPending
                                        ? Styles.disabled
                                        : Styles[userLabs[activeStep].status.toLowerCase().replace('_', '-')]
                                        }`}
                                >
                                    {userLabs[activeStep]?.isPending ? "License Expired" : userLabs[activeStep]?.status === "not_started" ? "Start Learning" : userLabs[activeStep]?.status === "completed" ? "Completed" : userLabs[activeStep]?.status === "failed" ? "Failed" : "Continue Learning"}
                                </span>
                            </div>
                            <p
                                data-testid="certLearningPath-detailsDescription"
                                className={Styles.detailsDescription}
                                title={userLabs[activeStep].descr}
                            >
                                {userLabs[activeStep].descr.length > 250
                                    ? userLabs[activeStep].descr.substring(0, 250) + "..."
                                    : userLabs[activeStep].descr}
                            </p>

                            <div data-testid="certLearningPath-detailsStats" id="detailsStats" className={Styles.detailsStats}>
                                <div data-testid="certLearningPath-detailStat" id="durationStat" className={Styles.detailStat}>
                                    <AccessTimeOutlinedIcon data-testid="certLearningPath-detailIcon" className={Styles.detailIcon} />
                                    <div data-testid="certLearningPath-detailLabel" id="detailLabel">
                                        <p className={Styles.detailLabel}>{props.t(`LearningPath.CertLearningPath.certBody.duration`)}</p>
                                        <p className={Styles.detailValue}>
                                            {getLabHours(userLabs[activeStep].id)} Hours
                                        </p>
                                    </div>
                                </div>

                                <div data-testid="certLearningPath-detailStat-moduleStat" id="moduleStat" className={Styles.detailStat}>
                                    <ImportContactsOutlinedIcon className={Styles.detailIcon} />
                                    <div data-testid="certLearningPath-detailLabel" id="detailLabel">
                                        <p className={Styles.detailLabel}>{props.t(`LearningPath.CertLearningPath.certBody.modules`)}</p>
                                        <p className={Styles.detailValue}>
                                            {data?.labs.filter(x => x.id === userLabs[activeStep].id)[0].nodeCount + " "}
                                            {props.t(`LearningPath.CertLearningPath.certBody.modules`)}
                                        </p>
                                    </div>
                                </div>

                                <div data-testid="certLearningPath-scoreStat" id="scoreStat" className={Styles.detailStat}>
                                    <WorkspacePremiumOutlinedIcon className={Styles.detailscore} />
                                    <div data-testid="certLearningPath-detailLabel"
                                        id="detailLabel"
                                    >
                                        <p className={Styles.detailLabel}>{props.t(`LearningPath.CertLearningPath.certBody.score`)}</p>
                                        <p className={Styles.detailValue}>{userLabs[activeStep].score}/10</p>
                                    </div>
                                </div>
                            </div>

                            <div data-testid="certLearningPath-progressSection" id="progressSection" className={Styles.progressSection}>
                                <Tooltip arrow placement='right'>
                                    <div data-testid="certLearningPath-progress" id="progress" style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        width: "100%",
                                        alignSelf: "flex-end",
                                        marginTop: '4px',

                                    }}>
                                        <LinearProgress
                                            variant="determinate"
                                            value={userLabs[activeStep].completion_percentage}
                                            className={Styles.progessBar}
                                            sx={{
                                                backgroundColor: (userLabs[activeStep].status !== "Started" && userLabs[activeStep].status !== "Completed") ? "grey" : "#6382702e",
                                                "& .MuiLinearProgress-bar": {
                                                    backgroundColor: "#008037",
                                                },
                                            }}
                                        />

                                        <p styles={{ fontSize: "12px" }}>{userLabs[activeStep].completion_percentage}%</p>
                                    </div>
                                </Tooltip>
                                <p data-testid="certLearningPath-progressMessage" className={Styles.progressMessage}>{props.t(`LearningPath.CertLearningPath.certBody.progressMessage`)}</p>
                            </div>
                        </div>

                        <div data-testid="certLearningPath-actionSection" id="actionSection" className={Styles.actionSection}>
                            <button
                                data-testid="certLearningPath-learningPathButton" id="learningPathButton"
                                onClick={() => {
                                    if (userLabs[activeStep].isPending) {
                                        return props?.expiredRedirection && navigate(props?.expiredRedirection)
                                    } else {
                                        setIsLoadingOpen(true);
                                        labButtonClick(userLabs[activeStep]);
                                    }
                                }}
                                className={Styles.btnContinue}
                            >
                                {userLabs[activeStep].isPending ? (
                                    props.t("LearningPath.CertLearningPath.button.disabled")
                                ) : (
                                    props.t(`LearningPath.CertLearningPath.button.${userLabs[activeStep].status}`)
                                )}

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}